import React from 'react';
import { 
  LuCalendar, 
  LuSlidersHorizontal, 
  LuDownload, 
  LuShieldAlert, 
  LuCalendarDays, 
  LuFileText 
} from 'react-icons/lu';

// Safe, version-independent status indicators
import { 
  FiCheckCircle, 
  FiClock, 
  FiAlertTriangle 
} from 'react-icons/fi';

export default function FireSafetyComplianceOverview() {
  // Stat cards matching the image content and styles
  const stats = [
    {
      id: 1,
      title: 'Fire Safety Items',
      value: '38',
      subtext: 'All locations',
      icon: LuShieldAlert,
      iconColor: 'text-blue-600',
      bgColor: 'bg-blue-50/70',
    },
    {
      id: 2,
      title: 'Compliant',
      value: '33',
      subtext: 'Up to date',
      icon: FiCheckCircle, // <--- CHANGED FROM LuCheckCircle2 TO FiCheckCircle
      iconColor: 'text-emerald-600',
      bgColor: 'bg-emerald-50/70',
    },
    {
      id: 3,
      title: 'Action Due',
      value: '3',
      subtext: 'Requires attention',
      icon: FiClock, // <--- CHANGED FROM LuClock TO FiClock
      iconColor: 'text-orange-500',
      bgColor: 'bg-orange-50/70',
    },
    {
      id: 4,
      title: 'Overdue',
      value: '2',
      subtext: 'Overdue items',
      icon: FiAlertTriangle, // <--- CHANGED FROM LuAlertTriangle TO FiAlertTriangle
      iconColor: 'text-rose-600',
      bgColor: 'bg-rose-50/70',
    },
    {
      id: 5,
      title: 'Next Due',
      value: '22 Jul 2026',
      subtext: '4 days remaining',
      icon: LuCalendarDays,
      iconColor: 'text-indigo-600',
      bgColor: 'bg-indigo-50/70',
    },
    {
      id: 6,
      title: 'Documents',
      value: '8',
      subtext: 'Available',
      icon: LuFileText,
      iconColor: 'text-blue-600',
      bgColor: 'bg-blue-50/70',
    },
  ];

  return (
    <div className="w-full bg-slate-50 p-6 font-sans">
      
      {/* Header Layout */}
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold text-indigo-950 tracking-tight">
            Fire Safety Compliance Overview <span className="font-medium text-slate-800">(Inspector View)</span>
          </h1>
          <p className="text-xs font-medium text-slate-400 mt-1">
            Evidence of fire safety compliance, testing and certification records.
          </p>
        </div>

        {/* Action Controls Menu */}
        <div className="flex flex-wrap items-center gap-2 self-start lg:self-center">
          {/* Calendar Picker Wrapper */}
          <button className="flex items-center gap-2 px-3 py-2 bg-white border border-slate-200/80 rounded-xl text-xs font-semibold text-slate-700 hover:bg-slate-50 transition-colors shadow-sm">
            <LuCalendar className="text-slate-700 text-sm stroke-[2.5]" />
            <span>18 Jul 2026 - 18 Jul 2026</span>
            <span className="text-[9px] text-slate-400 ml-1">▼</span>
          </button>

          {/* Filter Trigger Button */}
          <button className="flex items-center gap-1.5 px-3 py-2 bg-white border border-slate-200/80 rounded-xl text-xs font-semibold text-slate-700 hover:bg-slate-50 transition-colors shadow-sm">
            <LuSlidersHorizontal className="text-slate-700 text-sm stroke-[2.5]" />
            <span>Filters</span>
          </button>

          {/* Data Export Button */}
          <button className="flex items-center gap-1.5 px-4 py-2 bg-white border border-slate-200/80 rounded-xl text-xs font-semibold text-slate-700 hover:bg-slate-50 transition-colors shadow-sm">
            <LuDownload className="text-slate-700 text-sm stroke-[2.5]" />
            <span>Export</span>
          </button>
        </div>
      </div>

      {/* Metric Cards Layout Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 w-full max-w-[1800px] mx-auto">
        {stats.map((stat) => {
          const IconComponent = stat.icon;
          return (
            <div 
              key={stat.id} 
              className="flex items-center gap-4 bg-white border border-slate-100 rounded-2xl p-4 shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Boxed Icon Frame Wrapper */}
              <div className={`p-3 rounded-2xl ${stat.bgColor} flex-shrink-0 flex items-center justify-center`}>
                <IconComponent className={`text-xl ${stat.iconColor} stroke-[2.5]`} />
              </div>

              {/* Statistical Value Readout Container */}
              <div className="min-w-0 flex flex-col justify-center">
                <p className="text-[11px] font-bold text-slate-500 tracking-wide mb-0.5">
                  {stat.title}
                </p>
                <p className="text-[20px] font-extrabold text-indigo-950 leading-none my-0.5">
                  {stat.value}
                </p>
                <p className="text-[10px] font-medium text-slate-400 mt-0.5">
                  {stat.subtext}
                </p>
              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
}
